const com = [
    {
        depth2: '약관팝업',
        depth3: '',
        depth4: '',
        depth5: '',
        name: '약관팝업',
        type: 'POPUP',
        dir: 'com',
        id: 'SC-COM-0002-P',
        plan: '25.05.29',
        end: '25.06.17',
        user: '김익중',
        state: '완료',
        etc: '솔루션 제작 화면 사용, 25.06.16 디자인 수정',
        uxw: true,
    },
    {
        depth2: '신규계좌 비밀번호 입력',
        depth3: '',
        depth4: '',
        depth5: '',
        name: '신규계좌 비밀번호 입력',
        type: 'PAGE',
        dir: 'com',
        id: 'SC-COM-0004-F',
        devUrl: 'prd/com/PRDCOM0101.tsx',
        plan: '25.05.09',
        end: '25.05.07',
        user: '김익중',
        state: '완료',
        etc: '25.05.13 타이틀 br 태그 삭제, 25.05.13: 아코디언 오류 수정(class추가), 250602:제목문구수정.클레스 및 영역수정.버튼수정,250605:영역추가및수정,250611:영역수정 및 컴포넌트수정, 250829 ATM출금방법 수정',
        uxw: true,
    },
    {
        depth2: '마케팅 수신 동의 확인',
        depth3: '',
        depth4: '',
        depth5: '',
        name: '마케팅 수신 동의 확인',
        type: 'POPUP',
        dir: 'com',
        id: 'SC-COM-0006-P',
        plan: '25.05.09',
        end: '25.05.08',
        user: '김익중',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: '휴대폰 본인인증',
        depth3: '',
        depth4: '',
        depth5: '',
        name: '인증 휴대폰 본인인증',
        type: 'PAGE',
        dir: 'com',
        id: 'SC-COM-1000-F',
        devUrl: 'com/ath/COMATH0102.tsx',
        plan: '25.05.02',
        end: '25.04.28',
        user: '김익중',
        state: '완료',
        etc: '약관팝업 작업중, 25.05.12 inputmode 수정, 25.05.13 통신사선택 팝업 화면ID 수정, 25.05.16 SCCOM1002P 팝업 타이틀 수정 / 하단 버튼 삭제, 250523 상단타이틀 추가 / 신분증 유형란 삭제 / 주민번호 ui수정 / 발급일자 수정, 25.06.04 기획 수정사항 반영, 25.06.18 기획 수정사항 반영',
        uxw: true,
    },
    {
        depth2: '사전 준비물 안내',
        depth3: '',
        depth4: '',
        depth5: '',
        name: '인증 사전 준비물 안내',
        type: 'PAGE',
        dir: 'com',
        id: 'SC-COM-1001-F',
        devUrl: 'com/ath/COMATH0101.tsx',
        plan: '25.05.02',
        end: '25.04.24',
        user: '김익중',
        state: '완료',
        etc: '250428:유의사항 닫쳐있을때가 기본으로 수정, 250429: 유의사항 공통수정, 25.06.18 기획 수정사항 반영, 250701:문구수정,250801:ibk로고추가',
        uxw: true,
    },
    {
        depth2: '신분증인증(OCR)',
        depth3: '신분증 인증방법 선택',
        depth4: '',
        depth5: '',
        name: '신분증인증(OCR) 신분증 인증방법 선택',
        type: 'PAGE',
        dir: 'com',
        id: 'SC-COM-1011-F',
        devUrl: 'com/ocr/COMOCR0101.tsx',
        plan: '25.04.30',
        end: '25.04.24',
        user: '김익중',
        state: '완료',
        etc: '250429: 꼭알아두세요 공통수정, 250514:띄어쓰기 수정 및 문구수정, 25.06.18 기획 수정사항 반영',
        uxw: true,
    },
    {
        depth2: '신분증인증(OCR)',
        depth3: '신분증 촬영',
        depth4: '신분증 촬영안내',
        depth5: '',
        name: '신분증 촬영 신분증 촬영안내',
        type: 'PAGE',
        dir: 'com',
        id: 'SC-COM-1012-F',
        devUrl: 'com/ocr/COMOCR0102.tsx',
        plan: '25.05.02',
        end: '25.04.24',
        user: '김익중',
        state: '완료',
        etc: '250514:띄어쓰기 수정, 250618 신분증 인증 방법 변경 수정',
        uxw: true,
    },
    {
        depth2: '신분증인증(OCR)',
        depth3: '신분증 촬영',
        depth4: '신분증 촬영',
        depth5: '',
        name: '신분증 촬영 신분증 촬영',
        type: 'PAGE',
        dir: 'com',
        id: 'SC-COM-1013-F',
        devUrl: 'com/ocr/COMOCR0104.tsx',
        plan: '25.05.15',
        end: '25.05.08',
        user: '김익중',
        state: '완료',
        etc: '25.05.12 inputmode 수정, 250523 주민번호 ui수정',
        uxw: true,
    },
    {
        depth2: '신분증인증(OCR)',
        depth3: '신분증 촬영',
        depth4: '신분증 확인(수정)',
        depth5: '',
        name: '신분증 촬영 신분증 확인(수정)',
        type: 'PAGE',
        dir: 'com',
        id: 'SC-COM-1015-F',
        plan: '25.05.15',
        end: '25.05.08',
        user: '김익중',
        state: '삭제',
        etc: '25.05.12 inputmode 수정, 25.05.13 화면 삭제',
    },
    {
        depth2: '신분증인증(OCR)',
        depth3: '모바일신분증',
        depth4: '모바일신분증 제출안내',
        depth5: '',
        name: '모바일 신분증 제출안내설명',
        type: 'PAGE',
        dir: 'com',
        id: 'SC-COM-1016-F',
        devUrl: 'com/ocr/COMOCR0105.tsx',
        plan: '25.06.13',
        end: '25.04.25',
        user: '김익중',
        state: '완료',
        etc: '250514:띄어쓰기, 괄호누락 수정, 25.06.18 기획 수정사항 반영, 25.07.04 문구수정',
        uxw: true,
    },
    {
        depth2: '신분증인증(OCR)',
        depth3: '모바일신분증',
        depth4: '모바일신분증 제출 확인',
        depth5: '',
        name: '모바일신분증 제출 확인',
        type: 'PAGE',
        dir: 'com',
        id: 'SC-COM-1017-F01',
        devUrl: '',
        plan: '25.07.03',
        end: '25.07.03',
        user: '김익중',
        state: '완료',
        etc: '최초소스, 250715: 체크이미지 로띠변경',
        uxw: true,
    },
    {
        depth2: '신분증인증(OCR)',
        depth3: '모바일신분증',
        depth4: '모바일신분증 제출 확인',
        depth5: '',
        name: '모바일신분증 제출 확인 실패',
        type: 'PAGE',
        dir: 'com',
        id: 'SC-COM-1017-F02',
        devUrl: '',
        plan: '25.07.03',
        end: '25.07.03',
        user: '김익중',
        state: '완료',
        etc: '최초소스, 250715: 체크이미지 로띠변경',
        uxw: true,
    },
    {
        depth2: '신분증인증(OCR)',
        depth3: '모바일신분증',
        depth4: '모바일신분증 제출 확인',
        depth5: '',
        name: '모바일신분증 제출 확인 실패',
        type: 'PAGE',
        dir: 'com',
        id: 'SC-COM-1017-F03',
        devUrl: '',
        plan: '25.07.03',
        end: '25.07.03',
        user: '김익중',
        state: '완료',
        etc: '최초소스, 250715: 체크이미지 로띠변경',
        uxw: true,
    },
    {
        depth2: '금융거래한도계좌안내',
        depth3: '',
        depth4: '',
        depth5: '',
        name: '금융거래한도계좌안내',
        type: 'POPUP',
        dir: 'com',
        id: 'SC-COM-0017-P',
        plan: '25.06.05',
        end: '25.05.28',
        user: '김익중',
        state: '완료',
        etc: '25.05.28 최초완료버전, 25.06.18 기획 수정사항 반영',
        uxw: true,
    },
    {
        depth2: '고객정보입력',
        depth3: '',
        depth4: '',
        depth5: '',
        name: '고객정보입력',
        type: 'PAGE',
        dir: 'com',
        id: 'SC-COM-1021-F',
        devUrl: 'com/ath/COMATH0201.tsx',
        plan: '25.05.16',
        end: '25.05.02',
        user: '김익중',
        state: '완료',
        etc: 'SC-COM-1024-P / SC-COM-1025-P / SC-COM-1026-P 포함, 25.05.13 전체팝업 화면ID 수정, 250514:띄어쓰기 수정, 25.05.16 특정금융거래 정보의..팝업 추가. 관련 체크박스 수정, 25.06.18 기획 수정사항 반영, 25.07.03 우편번호 버튼 수정',
        uxw: true,
    },
    {
        depth2: '고객정보입력',
        depth3: '우편번호검색',
        depth4: '도로명주소',
        depth5: '',
        name: '우편번호 주소찾기',
        type: 'POPUP',
        dir: 'com',
        id: 'SC-COM-1022-P',
        devUrl: 'com/ath/COMATH0202.tsx',
        plan: '25.05.30',
        end: '25.04.29',
        user: '김익중',
        state: '완료',
        etc: '250429 SC-COM-1023-P도 같이 포함, 250523 기획 수정에 따른 ui수정',
        uxw: true,
    },
    {
        depth2: '고객정보입력',
        depth3: '',
        depth4: '',
        depth5: '',
        name: '고객정보입력(체크카드용)',
        type: 'PAGE',
        dir: 'com',
        id: 'SC-COM-1028-F',
        plan: '25.05.22',
        end: '25.05.22',
        user: '김익중',
        state: '삭제',
        etc: '25.05.22 화면추가',
    },
    {
        depth2: '은행계좌확인',
        depth3: '계좌인증',
        depth4: '',
        depth5: '',
        name: '계좌인증',
        type: 'PAGE',
        dir: 'com',
        id: 'SC-COM-1031-F',
        devUrl: 'com/ath/COMATH0301.tsx',
        plan: '25.04.29',
        end: '25.04.29',
        user: '김익중',
        state: '완료',
        etc: 'SC-COM-1032-P 포함, 25.05.12 inputmode 수정, 25.05.13 계좌인증 IBK 계좌선택 팝업 (SC-COM-1034-P) 화면ID 수정, 250514: 마침표누락수정, 25.06.18 기획수정 반영, 25.06.20 비밀번호 입력 추가, 25.07.03 하단버튼 문구수정, 250909 은행선택 탭 수정',
        uxw: true,
    },
    {
        depth2: '은행계좌확인',
        depth3: '계좌인증',
        depth4: '',
        depth5: '',
        name: '계좌인증',
        type: 'PAGE',
        dir: 'com',
        id: 'SC-COM-1031-F1',
        devUrl: 'com/ath/COMATH0301.tsx',
        plan: '25.04.29',
        end: '25.04.29',
        user: '김익중',
        state: '완료',
        etc: '탭1개일때 케이스',
        uxw: true,
    },
    {
        depth2: '은행계좌확인',
        depth3: '인증번호검증',
        depth4: '',
        depth5: '',
        name: '계좌 인증번호 검증',
        type: 'POPUP',
        dir: 'com',
        id: 'SC-COM-1033-P',
        plan: '25.04.29',
        end: '25.04.28',
        user: '김익중',
        state: '수정',
        etc: '25.05.12 inputmode 수정, 25.05.13 파일명 수정, 250514:띄어쓰기 수정, 250602:제목문구수정 및 토스트팝업수정, 250905 입금자명 케이스추가, 250909 인증안내 영역 수정, 250910 인증안내 영역 수정',
        uxw: true,
    },
    {
        depth2: '안면인증',
        depth3: '안면인증 안내',
        depth4: '',
        depth5: '',
        name: '안면인증 안내',
        type: 'PAGE',
        dir: 'com',
        id: 'SC-COM-1041-F',
        devUrl: 'com/fac/COMFAC0101.tsx',
        plan: '25.06.13',
        end: '25.04.25',
        user: '김익중',
        state: '완료',
        etc: '동의서 약관팝업같이 추가되어있습니다. SC-COM-1042-F, 250602: 제목문구 수정.체크박스영역추가.인증하기 disabled추가, 25.06.18 기획수정 반영, 25.07.22 상단 이미지 수정',
        uxw: true,
    },
    {
        depth2: '안면인증',
        depth3: '에러 안내',
        depth4: '촬영시간 경과',
        depth5: '',
        name: '안면인증 에러 안내',
        type: 'PAGE',
        dir: 'com',
        id: 'SC-COM-1042-F1',
        plan: '25.06.16',
        end: '25.04.25',
        user: '김익중',
        state: '완료',
        etc: '25.04.25 최초완료버전, 25.06.18 기획수정 반영,250701:문구수정, 250715: 체크이미지 로띠변경',
        uxw: true,
    },
    {
        depth2: '안면인증',
        depth3: '에러 안내',
        depth4: '인증 실패',
        depth5: '',
        name: '안면인증 에러 안내',
        type: 'PAGE',
        dir: 'com',
        id: 'SC-COM-1042-F2',
        plan: '25.06.16',
        end: '25.04.25',
        user: '김익중',
        state: '완료',
        etc: '25.04.25 최초완료버전, 25.06.18 기획수정 반영, 250715: 체크이미지 로띠변경',
        uxw: true,
    },
    {
        depth2: '로딩(화면이동 시)',
        depth3: '',
        depth4: '',
        depth5: '',
        name: '로딩(화면이동 시)',
        type: 'PAGE',
        dir: 'com',
        id: 'SC-COM-2000-F',
        plan: '25.07.18',
        end: '25.07.15',
        user: '김익중',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: '로딩(데이터로드 실패)',
        depth3: '',
        depth4: '',
        depth5: '',
        name: '로딩(데이터로드 실패)',
        type: 'PAGE',
        dir: 'com',
        id: 'SC-COM-2000-F1',
        plan: '25.07.18',
        end: '25.07.15',
        user: '김익중',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: '로딩(접속 실패)',
        depth3: '',
        depth4: '',
        depth5: '',
        name: '로딩(접속 실패)',
        type: 'PAGE',
        dir: 'com',
        id: 'SC-COM-2000-F2',
        plan: '25.07.18',
        end: '25.07.15',
        user: '김익중',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: '공유하기',
        depth3: '',
        depth4: '',
        depth5: '',
        name: '공유하기',
        type: 'PAGE',
        dir: 'com',
        id: 'SC-COM-2001-P',
        plan: '25.06.20',
        end: '25.06.20',
        user: '김익중',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: '대기창 팝업(유량제어)',
        depth3: '',
        depth4: '',
        depth5: '',
        name: '대기창 팝업(유량제어)',
        type: 'PAGE',
        dir: 'com',
        id: 'SC-COM-2005-P',
        plan: '25.07.18',
        end: '',
        user: '김익중',
        state: '삭제',
        etc: 'NetFUNNEL 에서 작업',
    },
]

export default com
